import { render } from "./WerkervaringPage.vue?vue&type=template&id=fa90c8b6&scoped=true"
import script from "./WerkervaringPage.vue?vue&type=script&lang=js"
export * from "./WerkervaringPage.vue?vue&type=script&lang=js"

import "./WerkervaringPage.vue?vue&type=style&index=0&id=fa90c8b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa90c8b6"]])

export default __exports__